import { render, staticRenderFns } from "./PostReply.vue?vue&type=template&id=e187c9e6&"
import script from "./PostReply.vue?vue&type=script&lang=js&"
export * from "./PostReply.vue?vue&type=script&lang=js&"
import style0 from "./PostReply.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports